import Ws from "../../providers/Ws";
import AnalizeClienti from "./Analize";
import SpecificComponent from "../../commons/SpecificComponent";

export default class FromServer extends SpecificComponent {
    getBalanteBilanturi = async () => {
        let ws = new Ws();

        let balante = ws.customSelect('select * from fin_import_balanta_lunara_head', {
            p1: 1
        })

        let bilanturi = ws.customSelect('select * from fin_import_bilant_head', {
            p1: 1
        })

        let [ba, bi] = await Promise.all([balante, bilanturi])


        if (ba.Succes && bi.Succes) {

            let bilanturiS = bi.Content.sort((a, b) => {
                let data1 = new Date().setFullYear(a.an)
                data1 = new Date(data1).setMonth(a.luna)

                let data2 = new Date().setFullYear(b.an)
                data2 = new Date(data2).setMonth(b.luna)

                return new Date(data2) - new Date(data1)
            })

            let balanteS = ba.Content.sort((a, b) => {
                let data1 = new Date().setFullYear(a.an)
                data1 = new Date(data1).setMonth(a.luna)

                let data2 = new Date().setFullYear(b.an)
                data2 = new Date(data2).setMonth(b.luna)

                return new Date(data2) - new Date(data1)
            })

            return { r: true, m: 'Success Preluare Date', c: { bilanturi: bilanturiS, balante: balanteS } }

        } else {
            return { r: false, m: { errBilant: ba.Messsage, errBalanta: bi.Message }, c: null }
        }


    }

    getBalanteRows = async (id) => {
        let ws = new Ws();

        let getRows = await ws.customSelect('select * from fin_import_balanta_lunara_rows where id_head = @p1 and isnull(sters,0) != 1', {
            p1: id
        })

        if (getRows.Succes) {
            return { r: true, m: getRows.Messsage, c: getRows.Content }
        } else {
            return { r: false, m: getRows.Messsage, c: null }
        }
    }

    getBilanturiRows = async (id) => {
        let ws = new Ws();

        let getRows = await ws.customSelect('select * from fin_import_bilant_rows where id_head = @p1 and isnull(sters,0) != 1', {
            p1: id
        })

        if (getRows.Succes) {
            return { r: true, m: getRows.Messsage, c: getRows.Content }
        } else {
            return { r: false, m: getRows.Messsage, c: null }
        }
    }


    insertBalanta = async (cols) => {
        let ws = new Ws()

        let insertBalanta = await ws.insert('fin_import_balanta_lunara_head', cols)


        if (insertBalanta.Succes) {
            return { r: true, m: insertBalanta.Messsage, c: insertBalanta.Content }
        } else {
            return { r: false, m: insertBalanta.Messsage, c: null }
        }
    }


    insertBilant = async (cols) => {
        let ws = new Ws()

        let insertBilant = await ws.insert('fin_import_bilant_head', cols)

        if (insertBilant.Succes) {
            return { r: true, m: insertBilant.Messsage, c: insertBilant.Content }
        } else {
            return { r: false, m: insertBilant.Messsage, c: null }
        }
    }


    addRowBilant = async (cols) => {

        let ws = new Ws();

        let insertRow = await ws.insert('fin_import_bilant_rows', cols)

        if (insertRow.Succes) {
            return { r: true, m: insertRow.Messsage, c: insertRow.c }
        } else {
            return { r: false, m: insertRow.Messsage, c: null }
        }

    }


    addRowBalanta = async (cols) => {
        let ws = new Ws();

        let insertRow = await ws.insert('fin_import_balanta_lunara_rows', cols)

        if (insertRow.Succes) {
            return { r: true, m: insertRow.Messsage, c: insertRow.c }
        } else {
            return { r: false, m: insertRow.Messsage, c: null }
        }
    }

    deleteRowBilant = async (cols, where) => {
        let ws = new Ws();

        let deleteRowBilant = await ws.update('fin_import_bilant_rows', cols, where)

        if (deleteRowBilant.Succes) {
            return { r: true, m: deleteRowBilant.Messsage, c: deleteRowBilant.Content }
        } else {
            return { r: false, m: deleteRowBilant.Messsage, c: null }
        }
    }

    deleteRowBalanta = async (cols, where) => {
        let ws = new Ws();

        let deleteRowBalanta = await ws.update('fin_import_balanta_lunara_rows', cols, where)

        if (deleteRowBalanta.Succes) {
            return { r: true, m: deleteRowBalanta.Messsage, c: deleteRowBalanta.Content }
        } else {
            return { r: false, m: deleteRowBalanta.Messsage, c: null }
        }
    }

    getRealizatPlanificat = async () => {

        let analize = new AnalizeClienti()

        let ws = new Ws();

        let venituri = analize.comparatieVenituriRealizatPlanificat(new Date().getFullYear())

        let cheltuieli = analize.comparatieCheltuieliRealizatPlanificat(new Date().getFullYear())

        let plan = ws.customSelect('select * from planificare_venituri_cheltuieli where an = @p1', {
            p1: new Date().getFullYear()
        })

        let [v, c, p] = await Promise.all([venituri, cheltuieli, plan])

        return { venituri: v, cheltuieli: c, plan: p.Content }
    }


    getIndicatoriFinanciar = async (id) => {
        let ws = new Ws()

        let indicatori = ws.customSelect('select id, simbol from fin_indicatori_financiari where isnull(sters, 0 ) != 1', {
            p1: 1
        })

        let indicatoriIstoric = ws.customSelect(`select top 100 i.*, it.simbol from fin_indicatori_financiari_istoric i left join fin_indicatori_financiari it
        on (i.id_indicator = it.id) where i.id_indicator = @p1`, {
                p1: id

            })

        let [i, iI] = await Promise.all([indicatori, indicatoriIstoric])


        if (i.Succes && iI.Succes) {

            let indiSorted = iI.Content.sort((a, b) => {

                let date1 = new Date().setFullYear(a.an)

                date1 = new Date(date1).setMonth(a.luna - 1)

                let date2 = new Date().setFullYear(b.an)
                date2 = new Date(date2).setMonth(b.luna - 1)


                return date2 - date1
            })
           
           
        //  console.log('object :',    this.mediaAritmetica(indiSorted, 12));

        let val = this.possibleOutcomeAbatere(indiSorted)

       //     let val = this.getPossibleOutcome(indiSorted)

           


        //   let arrTest=  [{an:2019, luna:4,valoare:4.7595 },
        //     {an:2019, luna:3, valoare:4.7583 },
        //     {an:2019, luna:2, valoare:4.7538 },
        //     {an:2019, luna:1, valoare:4.7487},
        //     {an:2019, luna:0, valoare:4.7037 }]

        //     this.possibleOutcome2(arrTest)
            return { r: true, m: 'Preluare date cu succes', c: { listIndicatori: i.Content, listIstoric: indiSorted, possibleOutcome: val } }

        } else {
            return { r: false, m: { errIndicatori: i.Messsage, errIndicatoriIstoric: iI.Messsage }, c: null }
        }
    }

    possibleOutcome2 = (arr) =>{

        let lunaCurenta = new Date().setMonth(arr[0].luna - 1)

        // console.log('lunaCurenta :',new Date(lunaCurenta) );

        let lunaUrmatoare = new Date(lunaCurenta).setMonth(new Date(lunaCurenta).getMonth() + 1)

        // console.log('lunaUrmatoare :',new Date(lunaUrmatoare) );


        let numbers = arr.slice(0,5).map((n,idx)=>{
           
        
                return {valoare:n.valoare, luna:n.luna, an:n.an}
            
        })

        // console.log('numbers :', numbers);
            let sum =0
        let n = numbers.map((n) => {sum += n.valoare});

        // console.log('sum :', sum);

        
        let rez = []
        let mArr = []

        for(let p1 = 0 ; p1 < 100 ; p1++){
            let l1 = 100 -p1
            for(let p2 = 0; p2 < l1; p2++){
                let l2 = 100 -p2
                for(let p3=0; p3< l2; p3++){
                    let l3 = 100 -p3
                    for(let p4=0; p4< l3; p4++){
                        let l4 = 100 -p4
                        for(let p5 =0; p5< l4; p5++){
                        // let p5 = 100 - (p1 + p2 + p3 + p4)
                        let m = numbers[0].valoare * p1 + numbers[1].valoare * p2 + numbers[2].valoare * p3 +numbers[3].valoare * p4 + numbers[4].valoare * p5
                         m = m / (p1 + p2 + p3 + p4 + p5) 
                        rez.push({p1:p1, p2:p2, p3:p3, p4:p4, p5:p5, m:m})
                        mArr.push(m)
                        }
                    }
                }
            }
        }
      
        let closest = mArr.reduce((p,c)=>{
            return (Math.abs(c - numbers[numbers.length - 1].valoare) < Math.abs(p -numbers[numbers.length - 1].valoare ) ? c : p)
        })

       let filter = rez.filter(r => r.m === 4.7037)

    //    console.log('filter :', filter);
    //     console.log('closest :', closest.toFixed(4));
    //     console.log('rez :', rez);
    //     console.log('numbers :', numbers);

    }



    getPossibleOutcome = (arr) => {
 
        let nr = []

        let a = new AnalizeClienti()

        for (let i = 0; i < 5; i++) {

            let dateNow = new Date()
            let date = a.addMonths(dateNow, -i)
            let anul = date.getFullYear()
            let luna = date.getMonth() 

   


            let val = arr.filter(a => (a.an === anul) && (a.luna === luna)).map(v => v.valoare)

            //console.log('val :', val);

            if (i < 3) {
                if (val.length > 0) {
                    nr.push(val[0])
                } else {
                    return null
                }

            } else {
                if (val.length > 0) {
                    nr.push(val[0])
                } else {
                    nr.push(0)
                }
            }

        }

        let pond = [0.5, 0.4, 0.3, 0.2, 0.1]

        let sumNr = 0
        let sumPond = pond.reduce((a, b) => a + b, 0)

       // console.log('sumPond :', sumPond);

        for (let i = 0, n = nr.length; i < n; i++) {
            sumNr += nr[i] * pond[i]
        }



        return (sumNr / sumPond).toFixed(4)
       // console.log('sumNr :', sumNr);
       // console.log('nr :', nr);




    }


    possibleOutcomeAbatere = (arr) =>{

        let obj = this.mediaAritmetica(arr,12)

        let counter = obj.nr.length

        let newNr = 0 

        for(let i = 0 ; i< counter; i++){
            newNr += -obj.nr[i] + Number(obj.media)
        }

        let medie =  (newNr / obj.nr.length).toFixed(4)

        // console.log('newNr :', newNr);

        // console.log('rrrrrrr :', arr[0].valoare + newNr);

        return (arr[0].valoare + newNr).toFixed(4)
        
   
        
    }


    mediaAritmetica = (arr, length) =>{
        
        let nr = []

        let a = new AnalizeClienti()

       // console.log('arr :', arr);

        for (let i = 0; i < length; i++) {

            let dateNow = new Date()
            let date = a.addMonths(dateNow, (-i - 1))
            let anul = date.getFullYear()
            let luna = date.getMonth()


            // console.log('anul :', date);


            // console.log('luna :', luna);
            let val = arr.filter(a => (a.an === anul) && (a.luna === luna + 1)).map(v => v.valoare)

            // console.log('val :', val);

            if (i < length) {
                if (val.length > 0) {
                    nr.push(val[0])
                } else {
                    nr.push(0)
                }

            } else {
                if (val.length > 0) {
                    nr.push(val[0])
                } else {
                    nr.push(0)
                }
            }

        }

        // console.log('nr :', nr);
        let sumNr = 0
    

      

        for (let i = 0, n = nr.length; i < n; i++) {
            sumNr += nr[i] 
        }
    


        return {nr:nr, media:(sumNr / length).toFixed(4)} 
       
    }


    getEvaluare = async () => {
        let ws = new Ws();

        let date = new Date().getFullYear() - 1

        // console.log('date :', date);

        let _getEvaluare = ws.getData('EvaluareFinanciara/GenerateEvaluareAnuala', { an: date })

        let _getTopProiecte = ws.getData('EvaluareFinanciara/TopProiecte', { nrElemente: 5 })

        let _raport = ws.customSelect(`select t.id,t.id_categorie,t.id_proiect,t.titlu,t.descriere,t.cand_data,t.cand_ora,t.pana_cand_data,t.pana_cand_ora,t.statusul,t.id_utilizator_responsabil,

        Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)  as dataora_propusa,   
        t.cand_finalizat as dataora_finalizare,
        
        DATEDIFF(HOUR, (Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)) , isnull(t.cand_finalizat,GetDate())  ) as ore_diferenta_completare,
        
        DATEDIFF(HOUR, (Cast(t.cand_data as datetime)  + Cast(isnull(t.cand_ora,'09:00') as datetime)) , ( Cast(t.pana_cand_data as datetime) +Cast( isnull(t.pana_cand_ora,'23:59') as datetime))  ) ore_durata,
        
        u.nume as nume_user, p.titlu as nume_proiect , p.descriere as descriere_proiect, p.perioada_dela as start_proiect, perioada_panala as end_proiect
        
        from taskuri t left outer join useri u on (t.id_utilizator_responsabil = u.id ) left outer join proiecte p on(t.id_proiect = p.id) where isnull(t.inactiv,0) != @p1 `,
            { p1: 1 })

        let _getSold = ws.getData('Balanta/SolduriFurnizoriClienti', { an: date })

        let [getEvaluare, raport, getSold, getTopProiecte] = await Promise.all([_getEvaluare, _raport, _getSold, _getTopProiecte])

      

        if (getEvaluare.Succes && raport.Succes && getSold.Succes && getTopProiecte.Succes) {

            // console.log('getTopProiecte :', getTopProiecte);



            // console.log('getEvaluare :', getEvaluare);
            // console.log('getSold :', getSold);


            
            let capitole = [...new Set(getEvaluare.Content.map((c) => { return c.Capitol }))]

            let categorii = [...new Set(getEvaluare.Content.map((c) => { return c.Categorie }))]

            // console.log('categorii :', categorii);
            // console.log('capitole :', capitole);


            let cCapitole = capitole.length




            let listCapitole = []



            for (let k = 0; k < cCapitole; k++) {

                let listCategorii = []

                let categoriiFilter = []
                for (let i = 0, n = getEvaluare.Content.length; i < n; i++) {

                    if (getEvaluare.Content[i].Capitol === capitole[k])


                        categoriiFilter.push(getEvaluare.Content[i].Categorie)

                }



                categoriiFilter = [...new Set(categoriiFilter)]

                // console.log('categoriiFilter :', categoriiFilter);

                let cCategorii = categoriiFilter.length


                for (let j = 0; j < cCategorii; j++) {



                    let chartData = []

                    for (let i = 0, n = getEvaluare.Content.length; i < n; i++) {


                        if (getEvaluare.Content[i].Categorie === categoriiFilter[j]) {

                            // chartData.push({
                            //     categorie:getEvaluare.Content[i].Categorie,
                            //     titlu: getEvaluare.Content[i].Titlu,
                            //     explicatie: getEvaluare.Content[i].Explicatie,
                            //     help: getEvaluare.Content[i].Help,
                            //     tipAnticipare: getEvaluare.Content[i].Anticipare.tip,
                            //     chartData: [['Titlu', 'Valoare Anterioara', 'Valoare Curenta'],
                            //     ['',
                            //     Number(getEvaluare.Content[i].ValoareAnterioara),
                            //     Number(getEvaluare.Content[i].ValoareCurenta)]],

                            // })


                            chartData.push({
                                categorie: getEvaluare.Content[i].Categorie,
                                titlu: getEvaluare.Content[i].Titlu,
                                explicatie: getEvaluare.Content[i].Explicatie,
                                help: getEvaluare.Content[i].Help,
                                tipAnticipare: getEvaluare.Content[i].Anticipare.tip,
                                culori: Number(getEvaluare.Content[i].ValoareAnterioara) > Number(getEvaluare.Content[i].ValoareCurenta) ? ['green', 'red'] : ['red', 'green'],
                                labels:[new Date(new Date().setFullYear(new Date().getFullYear() -1)).getFullYear(), new Date().getFullYear()],
                                // labels: [this.dictionary.financiarContabil.valoareAnterioara, this.dictionary.financiarContabil.valoareCurenta],
                                chartData: [
                                    Number(getEvaluare.Content[i].ValoareAnterioara),
                                    Number(getEvaluare.Content[i].ValoareCurenta)],

                            })









                        }
                    }



                    //     for (let i = 0, n = chartData.length; i < n; i++) {
                    //             if(getEvaluare.Content[i].Categorie === categoriiFilter[j]){
                    //                 chartData[i].chartData.push(['',
                    //                 Number(getEvaluare.Content[i].ValoareAnterioara),
                    //                 Number(getEvaluare.Content[i].ValoareCurenta)]);


                    //       break;
                    //     }
                    // }





                    listCategorii.push({ categorie: categoriiFilter[j], chartData: chartData })





                }



                listCapitole.push({ capitol: capitole[k], categorii: listCategorii })


            }

            // console.log('listCapitole :', listCapitole);


            let chartData = []

            for (let i = 0, n = getEvaluare.Content.length; i < n; i++) {



                // chartData.push({
                //     titlu: getEvaluare.Content[i].Titlu,
                //     explicatie: getEvaluare.Content[i].Explicatie,
                //     help: getEvaluare.Content[i].Help,
                //     tipAnticipare: getEvaluare.Content[i].Anticipare.tip,
                //     chartPrognoza: [['Titlu', 'Initiala', 'Finala', 'Anticipata']]
                // })

                chartData.push({
                    titlu: getEvaluare.Content[i].Titlu,
                    explicatie: getEvaluare.Content[i].Explicatie,
                    help: getEvaluare.Content[i].Help,
                    tipAnticipare: getEvaluare.Content[i].Anticipare.tip,
                    labels: [new Date().getFullYear() - 2, new Date().getFullYear() - 1, 'Prognozata'],
                    chartPrognoza: []
                })









            }
            for (let i = 0, n = chartData.length; i < n; i++) {


                // chartData[i].chartPrognoza.push([
                //     '',
                //     Number(getEvaluare.Content[i].Anticipare.valInitiala),
                //     Number(getEvaluare.Content[i].Anticipare.valFinala),
                //     Number(getEvaluare.Content[i].Anticipare.valoareAnticipata)
                // ])

                chartData[i].chartPrognoza.push(

                    Number(getEvaluare.Content[i].Anticipare.valInitiala),
                    Number(getEvaluare.Content[i].Anticipare.valFinala),
                    Number(getEvaluare.Content[i].Anticipare.valoareAnticipata)
                )
            }



            let listRaport = raport.Content



            let date = new Date().setDate(new Date().getDate() - 30)

            // console.log('date :', new Date(date));


            listRaport = listRaport.filter(r => new Date(r.dataora_propusa) > new Date(date))

            // console.log('listRaport :', listRaport);

            let userIds = listRaport.map(l => l.id_utilizator_responsabil)


            let userRez = []

            let users = [...new Set(userIds)]




            // console.log('users :', users);


            let counter = users.length


            for (let i = 0; i < counter; i++) {
                userRez.push(this.userAnalize1(users[i], listRaport))
            }


            let counter3 = userRez.length

            let chartData2 =
                {
                    chartData: [],

                    labels: [this.dictionary.financiarContabil.totalOreCumulateTaskuri,
                    this.dictionary.financiarContabil.totalOreDepasiteCompletare,
                    this.dictionary.financiarContabil.totalOreAvansCompletare,
                    this.dictionary.financiarContabil.procentajDepasire,
                    this.dictionary.financiarContabil.procentajAvans
                    ]

                }







            let chartProiecte = []

            // console.log('getTopProiecte.Content :', getTopProiecte.Content);
            let counterP = getTopProiecte.Content.length

        

            for (let i = 0; i < counterP; i++) {
                //  chartProiecte.push({titlu:getTopProiecte.Content[i].Titlu, 
                //                     chartData:[['Titlu', 'Durata', 'Etape', 'Taskuri']]})

                //  chartProiecte[i].chartData.push(['',Number(getTopProiecte.Content[i].Durata), Number(getTopProiecte.Content[i].Etape), Number(getTopProiecte.Content[i].Taskuri ) ])

                chartProiecte.push({
                    id:getTopProiecte.Content[i].Id,
                    titlu: getTopProiecte.Content[i].Titlu,
                    labels: [this.dictionary.financiarContabil.durata + ' (zile)', this.dictionary.financiarContabil.etape, this.dictionary.financiarContabil.taskuri],
                    chartData: []
                })

                chartProiecte[i].chartData.push(Number(getTopProiecte.Content[i].Durata), Number(getTopProiecte.Content[i].Etape), Number(getTopProiecte.Content[i].Taskuri))
            }



            for (let i = 0; i < counter3; i++) {


                // chartData2.push([
                //     userRez[i].numeUser,
                //     userRez[i].totalOreCumulateTaskuri,
                //     userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
                //     userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
                //     userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0,
                //     userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0,
                // ])



                chartData2.chartData.push({

                    user: userRez[i].numeUser, chartData: [

                        { label: this.dictionary.financiarContabil.totalOreCumulateTaskuri, value: userRez[i].totalOreCumulateTaskuri },
                        { label: this.dictionary.financiarContabil.totalOreDepasiteCompletare, value: userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                        { label: this.dictionary.financiarContabil.totalOreAvansCompletare, value: userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                        { label: this.dictionary.financiarContabil.procentajDepasire, value: userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0 },
                        { label: this.dictionary.financiarContabil.procentajAvans, value: userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0 }
                    ]

                })

                // chartData2.users.push(userRez[i].numeUser)
            }


            return {
                r: true, m: 'success preluare date', c: {
                    chartData: chartData,
                    listCapitole: listCapitole,
                    chartProiecte: chartProiecte,
                    listFull: raport.Content,
                    listRaport: userRez,
                    chartData2: chartData2,
                    listSold: getSold.Content.Content
                }
            }

        } else {
            return { r: false, m: 'eroare preluare date', c: null }
        }
    }
    userAnalize1 = (idUser, ds) => {

        let DT = ds.filter(l => (new Date(l.cand_data).setFullYear(new Date(l.cand_data) - 1) <= new Date(l.cand_data) && new Date(l.pana_cand_data) <= new Date()))
        DT = ds.filter(l => l.id_utilizator_responsabil === idUser)

        let nrTotalTaskuri = DT.length

        let nrTaskuriDepasite = DT.filter(d => Number(d.ore_diferenta_completare) > 0).length

        let nrTaskuriAvans = DT.filter(d => Number(d.ore_diferenta_completare) < 0).length

        let nrTaskuriInTermen = DT.filter(d => Number(d.ore_diferenta_completare) === 0).length

        let totalOreDepasire = DT.filter(d => (Number(d.ore_diferenta_completare) || 0) > 0).reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let totalOreCumulateTaskuri = DT.reduce((s, a) => s + (Number(a.ore_durata) || 0), 0)

        let totalOreDiferentaCompletare = DT.reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let pctDepasire = Number((totalOreDiferentaCompletare / (totalOreCumulateTaskuri || 1) * 100).toFixed(2))

        let totalOreAvans = DT.filter(d => Number(d.ore_diferenta_completare) < 0).reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let medieDepasirePerTask = Number((totalOreDepasire / (nrTotalTaskuri || 1)).toFixed(2))

        let medieAvansPerTask = Number((totalOreAvans / (nrTotalTaskuri || 1)).toFixed(2))

        let medieGenerala = Number((Number(medieAvansPerTask) - Math.abs(medieDepasirePerTask)).toFixed(2))

        let calificativMedie = medieGenerala < 0 ? this.dictionary.financiarContabil.pozitiva : this.dictionary.financiarContabil.negativa


        let numeUser = DT[0].nume_user

        return {
            nrTotalTaskuri,
            nrTaskuriDepasite,
            nrTaskuriAvans,
            nrTaskuriInTermen,
            totalOreDepasire,
            totalOreAvans,
            medieDepasirePerTask,
            medieAvansPerTask,
            medieGenerala,
            calificativMedie,
            numeUser,
            totalOreCumulateTaskuri,
            totalOreDiferentaCompletare,
            pctDepasire
        }



    }


    getFiseBilant = async () => {
        let ws = new Ws();

        let getFise = ws.customSelect(`select h.id,an,luna,(select count(*) from fin_import_bilant_rows where id_head = h.id) as linii 
                                        from fin_import_bilant_head h where isnull(sters,0) != @p1`, {
                p1: 1
            })

        let getBalanta = ws.customSelect(`select h.id,an,luna,(select count(*) from fin_import_balanta_lunara_rows where id_head = h.id) as linii 
        from fin_import_balanta_lunara_head h where isnull(sters,0) != @p1`, {
                p1: 1
            })

        let [f, b] = await Promise.all([getFise, getBalanta])


        if (f.Succes, b.Succes) {
            return {
                r: true, c: {
                    listFise: f.Content.filter(fb => fb.linii > 25),
                    listBalanta: b.Content.filter(bi => bi.linii > 5)
                },
                m: 'Succes preluare date'
            }
        } else {
            return { r: false, m: { err1: f.Messsage, err2: b.Messsage }, c: null }
        }
    }

    importBalantaLunaraHead = async (cols, where) => {
        let ws = new Ws();


        let update = await ws.update('fin_import_balanta_lunara_head', cols, where)

        if (update.Succes) {
            return { r: true, m: update.Message, }
        } else {
            return { r: false, m: update.Messsage }
        }


    }

    getDetaliiBilant = async () => {
        let ws = new Ws();


        let date = new Date().getFullYear() - 1


        let getBilant = await ws.customSelect('select * from fin_import_bilant_head where an = @p1 and isnull(sters,0) != 1', {
            p1: date
        })

        if (getBilant.Succes) {
            return { r: true, m: getBilant.Messsage, c: getBilant.Content }
        } else {
            return { r: false, m: getBilant.Messsage, c: getBilant.Content }
        }
    }

    updateBilant = async (cols, where) => {
        let ws = new Ws();



        let update = await ws.update('fin_import_bilant_head', cols, where)

        if (update.Succes) {
            return { r: true, m: update.Messsage }
        } else {
            return { r: false, m: update.Messsage }
        }
    }


    updateBalanta = async(cols,where) =>{
        let ws = new Ws();

        let update = await ws.update('fin_import_balanta_lunara_head', cols, where)

        if(update.Succes){
            return {r:true, m:update.Messsage}
        }else{
            return {r:false, m:update.Messsage}
        }
    }

    getIndicatoriIstoric = async (nrIndicator) => {
        let ws = new Ws()

        let indicatori = ws.customSelect('select id, simbol from fin_indicatori_financiari where isnull(sters,0) != 1', {
            p1: 1
        })

        let indicatoriIstoric = ws.customSelect(`select top 100 i.*, it.simbol from fin_indicatori_financiari_istoric i left join fin_indicatori_financiari it
        on (i.id_indicator = it.id) where i.id_indicator = @p1`, {
                p1:nrIndicator

            })

        let [i, iI] = await Promise.all([indicatori, indicatoriIstoric])

        // console.log('i :', i);

        if (i.Succes && iI.Succes) {

            let indiSorted = iI.Content.sort((a, b) => {

                let date1 = new Date().setFullYear(a.an)

                date1 = new Date(date1).setMonth(a.luna - 1)

                let date2 = new Date().setFullYear(b.an)
                date2 = new Date(date2).setMonth(b.luna - 1)


                return date2 - date1
            })


            let values = indiSorted.map(v => v.valoare)


         

             return {r:true, c:{listIndicatori:i.Content, listIstoric:indiSorted}, m:'Succes preluare date'}
        }else{
            return {r:false, m:'erroare preluare date', c:null}
        }
    }


    addIndicatorIstoric = async(obj) =>{
        let ws = new Ws()

        let addIndicator = await ws.insert('fin_indicatori_financiari_istoric', obj)

        if(addIndicator.Succes){
            return {r:true, m:addIndicator.Messsage, c:addIndicator.Content}
        }else{
            return {r:false, m:addIndicator.Messsage, c:null}
        }
    }

    getProfilogramaAndSolduriFurnizoriClienti = async(idHead) =>{
        let ws = new Ws()

        let date = new Date().getFullYear() - 1

        let _getData =  ws.getData('Bilant/Profilograma', {idHead:idHead})

        let _getSold =  ws.getData('Balanta/SolduriFurnizoriClienti', {an:date})


        let [getData,getSold] = await Promise.all([_getData, _getSold])


        if(getData.Succes && getSold.Succes){

            // console.log('getData :', getData);
            // console.log('getSold.Content.Content :', getSold.Content.Content);


            let listArray = []

            let listChart = []
 
            for(let [key, value] of Object.entries(getData.Content)){
                let obj = {nume:'', val:[]}

                if(key === 'PotentialFinanciar'){
                    for(let [key2,value2] of Object.entries(value)){
                        let objVal = {name:key2, val:value2}

                        obj.val.push(objVal)
                        obj.nume=key
                    }
                }else{
                    obj.nume=key
                    obj.val=value
                }
               

                listArray.push(obj)
            }

            // console.log('listArray :', listArray);

            let counter1 = listArray.length

     

            for(let i = 0 ; i< counter1; i++){
                let obj = {}
                let arr = []

                let counter2 = listArray[i].val.length

                // console.log('counter2 :', counter2);

                for(let j =0; j< counter2; j++){
                    if(listArray[i].val[j].ChartDataNewValue){

                        arr.push(listArray[i].val[j])
                    }
                }
                if(arr.length > 0){
                    obj.nume = listArray[i].nume
                    obj.val = arr
                    listChart.push(obj)
                }
            }

            // console.log('listChart :', listChart);

            let cloneListSold = getSold.Content.Content

            return {r:true, m:'Succes preluare date', c:{listTable:listArray, listChart:listChart, listSold:getSold.Content.Content}}

        }else{
            return {r:false, m:'eroare preluare date', c:null}
        }
    }

    getListPlanificare = async() =>{
        let ws = new Ws();

        let getListPlan = await ws.customSelect('select * from planificare_venituri_cheltuieli where isnull(sters,0) != @p1', {
            p1: 1
        })


        if(getListPlan.Succes){
            return {r:true, m:getListPlan.Messsage, c:getListPlan.Content}
        }else{
            return {r:false, m:getListPlan.Messsage}
        }
    }

    insertListPlan = async(objToInsert) =>{

        let ws = new Ws();
        
        let insertPlan = await ws.insert('planificare_venituri_cheltuieli', objToInsert)

        if(insertPlan.Succes){
            return {r:true, m:insertPlan.Messsage, c:insertPlan.Content}
        }else{
            return {r:false, m:insertPlan.Messsage, c:null}
        }
    }

    deleteRowPlan = async(cols, where) =>{
        let ws = new Ws();

        let delRow = await ws.update('planificare_venituri_cheltuieli',cols,where)

        if(delRow.Succes){
            return {r:true, m:delRow.Messsage}
        }else{
            return {r:false, m:delRow.Messsage}
        }
    }


}